// extracted by mini-css-extract-plugin
export default {"center":"Project_center__aL4Fr","browser":"Project_browser__7ihxW","browserInner":"Project_browserInner__IUZXU","separator":"Project_separator__vRxfE"};